import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useEffect, useState } from "react";
import { useGetStatusPlanQuery } from "services/api/warehouseApi";
import {
  setStatusPlan,
  StatusData,
  StatusResource,
} from "store/Slices/Status/statusSlice";
import { useAppDispatch } from "./StoreHooks";

export function useStatusService(
  storeNb: number,
  refetchToken: number,
  initialPlan?: StatusResource
): {
  data: StatusData[] | undefined;
  isLoading: boolean;
  error: FetchBaseQueryError | undefined;
} {
  const dispatch = useAppDispatch();
  const [activeStoreNb] = useState(storeNb);
  const {
    data,
    refetch,
    isLoading,
    isFetching,
    error: queryError,
  } = useGetStatusPlanQuery(storeNb, {
    skip: false,
  });

  const fetchedStatusPlan = data ? data.statusPlan : undefined;

  useEffect(() => {
    refetch();
  }, [refetchToken, refetch]);

  useEffect(() => {
    if (initialPlan) {
      dispatch(setStatusPlan(initialPlan.statusPlan));
    } else if (fetchedStatusPlan) {
      dispatch(setStatusPlan(fetchedStatusPlan!));
    }
  }, [dispatch, initialPlan, fetchedStatusPlan, activeStoreNb]);

  return {
    data: initialPlan ? initialPlan.statusPlan : fetchedStatusPlan,
    isLoading: isLoading || isFetching,
    error: queryError ? (queryError as FetchBaseQueryError) : undefined,
  };
}
